import React, { useState, useEffect } from 'react';
import { useGetUser, useSetUser } from '../../context/userContext';
import editUser from '../../api/editUser';

const Expectations = () => {
  const user = useGetUser();
  const setUser = useSetUser();
  const [edit, setEdit] = useState(false);
  const [userCopy, setUserCopy] = useState(user);

  useEffect(() => {
    setUserCopy(user);
  }, [user]);

  return (
    <div className="row mycard mb-5">
      <div className="col col-12">
        {edit ? <EditInfo userCopy={userCopy} setUserCopy={setUserCopy} user={user} setUser={setUser} setEdit={setEdit} /> : <Info userCopy={userCopy} setEdit={setEdit} />}
      </div>
    </div>
  );
};

export default Expectations;

const Info = ({ userCopy, setEdit }) => {
  return (
    <>
      <h2 className="heading">
        <span>
          <small>Expectations</small>
        </span>
        <button className="btn btn-sm profile-btn" onClick={() => setEdit(true)}>
          <i className="bi bi-pencil-fill"></i> Edit
        </button>
      </h2>
      <div className="content">
        <div className="main">
          <div className="row">
            <div className="col col-12 col-md-6 px-5 mb-3">
              {!userCopy.salary && !userCopy.acceptRemoteWork && userCopy?.preferedLocation?.length === 0 && (
                <div className="col col-12">
                  <span className="lead">No details has been provided yet.</span>
                </div>
              )}

              {userCopy.salary && (
                <>
                  <strong>Net salary:</strong> {userCopy.salary} net
                </>
              )}
            </div>

            <div className="col col-12 col-md-6 px-5">
              {userCopy?.preferedLocation?.length > 0 && (
                <>
                  <strong>Preferred location of work:</strong>
                  {userCopy.acceptRemoteWork && (
                    <p>
                      <big>
                        <i className="bi bi-check2-circle"></i>
                      </big>{' '}
                      I accept remote
                    </p>
                  )}
                  <ul>
                    {userCopy?.preferedLocation?.map((el) => (
                      <li key={el._id}>
                        {el.city}, {el.country}
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const EditInfo = ({ userCopy, setUserCopy, user, setUser, setEdit }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    editUser(userCopy, setUser);
    setEdit(false);
  };

  const handleCancel = () => {
    setUserCopy(user);
    setEdit(false);
  };

  const handleCityChange = (e, index) => {
    setUserCopy((prev) => {
      const arr = prev.preferedLocation;
      arr[index].city = e.target.value;
      return { ...prev, preferedLocation: arr };
    });
  };

  const handleCountryChange = (e, index) => {
    setUserCopy((prev) => {
      const arr = prev.preferedLocation;
      arr[index].country = e.target.value;
      return { ...prev, preferedLocation: arr };
    });
  };

  const handleAddLocation = () => {
    setUserCopy((prev) => {
      const arr = [...prev.preferedLocation];
      arr.push({ id: Date.now(), city: '', country: '' });
      return { ...prev, preferedLocation: arr };
    });
  };

  const handleRemoveLocation = (_id, id) => {
    if (_id) {
      setUserCopy((prev) => {
        const arr = prev.preferedLocation;
        const filtered = arr.filter((el) => el._id !== _id);
        return { ...prev, preferedLocation: filtered };
      });
    } else {
      setUserCopy((prev) => {
        const arr = prev.preferedLocation;
        const filtered = arr.filter((el) => el.id !== id);
        return { ...prev, preferedLocation: filtered };
      });
    }
  };

  return (
    <>
      <h2 className="heading">
        <small>Expectations</small>
        <span></span>
      </h2>
      <div className="content mx-5">
        <div className="main">
          <form className="row g-3" onSubmit={(e) => handleSubmit(e)}>
            <div className="col-12 col-md-12">
              <label htmlFor="inputSalary" className="form-label">
                Salary
              </label>
              <input
                type="text"
                className="form-control"
                id="inputSalary"
                placeholder="Salary"
                value={userCopy.salary}
                onChange={(e) =>
                  setUserCopy((prev) => {
                    return { ...prev, salary: e.target.value };
                  })
                }
              />
            </div>

            <div className="col-12">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="remote"
                  checked={userCopy.acceptRemoteWork}
                  onChange={(e) =>
                    setUserCopy((prev) => {
                      return { ...prev, acceptRemoteWork: !prev.acceptRemoteWork };
                    })
                  }
                />
                <label className="form-check-label ps-3" htmlFor="remote">
                  Accept remote work
                </label>
              </div>
            </div>

            <div className="col-12 col-md-12">
              <label className="form-label">Preferred location of work:</label>
              {userCopy.preferedLocation &&
                userCopy.preferedLocation.map((el, index) => (
                  <div className="row mb-3" key={index}>
                    <div className="col col-md-5">
                      <input type="text" className="form-control" placeholder="City" value={el.city} onChange={(e) => handleCityChange(e, index)} />
                    </div>
                    <div className="col col-md-5">
                      <input type="text" className="form-control" placeholder="Country" value={el.country} onChange={(e) => handleCountryChange(e, index)} />
                    </div>
                    <div className="col col-md-2 text-end">
                      <button type="button" className="btn btn-link del" onClick={() => handleRemoveLocation(el._id, el.id)}>
                        <i className="bi bi-trash"></i>
                      </button>
                    </div>
                  </div>
                ))}
              {userCopy.preferedLocation?.length < 5 && (
                <div>
                  <button type="button" className="btn btn-link btn-sm" onClick={handleAddLocation}>
                    <i className="bi bi-plus text-danger"></i> Add location
                  </button>
                </div>
              )}
            </div>

            <div className="col-12 text-end">
              <button type="button" className="btn profile-btn inver mb-1" onClick={handleCancel}>
                Cancel
              </button>
              <button type="submit" className="btn profile-btn mb-1 ms-3">
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
